import { jsx as _jsx } from "react/jsx-runtime";
import { InputNotice } from '#pplx/frontend/composer-sdk-plugins/internal/input-notice/InputNotice.js';
/** Renders non-empty quoted text into the composer `inputHeader` slot. */
export function QuoteSlotComponent({ preview, ...props }) {
    if (!props.message)
        return null;
    return preview ?? _jsx(InputNotice, { ...props });
}
//# sourceMappingURL=QuoteSlotComponent.js.map